import React from "react";

const HomeInformation = ({ content }) => {
  return (
    <div className="lg:mb-[112px] md:mb-16 sm:mb-9 mb-4 px-3">
      <div className="2xl:container">
        <div className="rounded-custom-30 border border-[#ECF1F6]">
          <div className="container">
            <div className="flex flex-col lg:pt-[60px] md:pt-8 pt-4 pb-4">
              <div
                dangerouslySetInnerHTML={{ __html: content }}
                className={`custom-scroll flex flex-col sm:mb-4 mb-2 gap-7 relative overflow-hidden transition-height duration-500 ease-in-out h-[300px] overflow-y-auto pr-5`}
              >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeInformation;
""